import type { MBCUIMessage } from "../types/mbc-chat.types";

export function getVisibleText(message: MBCUIMessage): string {
  return message.parts
    .filter((part) => part.type === "text")
    .map((part) => ("text" in part ? part.text : ""))
    .join("")
    .trim();
}

export function hasVisibleContent(message: MBCUIMessage): boolean {
  return (
    getVisibleText(message) !== "" ||
    message.parts.some((part) => part.type.startsWith("data-"))
  );
}
